const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * MENU EVENTS                                                                *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.menuBackLinkClicked, (item) => {
    pushEvent(
      createCustomEventGA4('menu_mobile', [
        ['action', 'back'],
        ['item', item],
      ])
    );
  });
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.menuCloseIconClicked, () => {
    pushEvent(
      createCustomEventGA4('menu_mobile', [
        ['action', 'close'],
        ['item', 'undefined'],
      ])
    );
  });
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.menuItemClicked, (item) => {
    pushEvent(
      createCustomEventGA4('menu_navigation', [
        ['action', 'click'],
        ['item', item],
      ])
    );
  });
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.menuOpenIconClicked, () => {
    pushEvent(
      createCustomEventGA4('menu_mobile', [
        ['action', 'open'],
        ['item', 'undefined'],
      ])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
